export default __webpack_public_path__ + "static/media/map.b41eee84.svg";